import React, { useState, useEffect } from 'react'

import { useNavigate } from 'react-router-dom';

import moment from 'moment';

import { SVGIcon } from '../wrappers/SVGIcon';

import { EExpertChatSource, EExpertConversationStatus, IExpertConversationWithChatsForUser } from '../../interfaces/expert_chats';

import { Icons } from '../../data/Assets';

interface IChatPreviewCardProps {
    expertConversation: IExpertConversationWithChatsForUser;
};

const ChatPreviewCard = (props: IChatPreviewCardProps) => {
    const { expertConversation } = props;

    const { id, student_name, status, expert_chats } = expertConversation;

    const lastMessage = expert_chats?.[expert_chats.length - 1] ? expert_chats[expert_chats.length - 1] : {
        id: 0,
        expert_conversation_id: expertConversation.id,
        source: EExpertChatSource.EXPERT,
        created_at: new Date(),
        message: 'New conversation has been created.',
    };

    const navigate = useNavigate();

    const [formattedTimestamp, setFormattedTimestamp] = useState('');

    useEffect(() => {
        const customFormatTimestamp = (timestamp: Date) => {
            const now = moment();
            const time = moment(timestamp);
            const diffInSeconds = now.diff(time, 'seconds');

            if (diffInSeconds < 60) {
                return `Now`;
            } else if (diffInSeconds < 3600) {
                return `${now.diff(time, 'minutes')}M`;
            } else if (diffInSeconds < 86400) {
                return `${now.diff(time, 'hours')}H`;
            } else if (diffInSeconds < 604800) {
                return `${now.diff(time, 'days')}D`;
            } else {
                return `${now.diff(time, 'weeks')}W`;
            }
        };

        setFormattedTimestamp(customFormatTimestamp(lastMessage.created_at));
        const interval = setInterval(() => {
            setFormattedTimestamp(customFormatTimestamp(lastMessage.created_at));
        }, 60 * 1000);

        return () => clearInterval(interval);
    }, [lastMessage.created_at]);

    const getFormattedStatus = (status: EExpertConversationStatus) => {
        switch (status) {
            case EExpertConversationStatus.OPEN:
                return 'Open';
            case EExpertConversationStatus.CLOSED:
                return 'Closed';
            default:
                return 'Waiting response';
        }
    };

    const handleClick = () => {
        navigate(`/immigration-help/details/${id}`);
    };

    return (
        <div className='immersion__chat_preview_card' onClick={handleClick}>
            <div className='immersion__chat_preview_card__header'>
                <div className='immersion__chat_preview_card__header__avatar'>
                    <SVGIcon src={Icons.UserCircleFill} />
                </div>
                <div className='immersion__chat_preview_card__header__content'>
                    <h5 className='immersion__chat_preview_card__header__content__name'>{student_name}</h5>
                    <p className='immersion__chat_preview_card__header__content__last_message mice'>{lastMessage.message}</p>
                </div>
                <p className={`immersion__chat_preview_card__header__status immersion__chat_preview_card__header__status__${status}`}>
                    {getFormattedStatus(status)}
                </p>
            </div>

            <div className='immersion__chat_preview_card__timestamp'>
                <p className='immersion__chat_preview_card__timestamp__text mice'>{formattedTimestamp}</p>
            </div>
        </div>
    )
}

export default ChatPreviewCard;